import { render, staticRenderFns } from "./ProductGeneralTab.vue?vue&type=template&id=aa9addb8&scoped=true"
import script from "./ProductGeneralTab.vue?vue&type=script&lang=ts"
export * from "./ProductGeneralTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9addb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa9addb8')) {
      api.createRecord('aa9addb8', component.options)
    } else {
      api.reload('aa9addb8', component.options)
    }
    module.hot.accept("./ProductGeneralTab.vue?vue&type=template&id=aa9addb8&scoped=true", function () {
      api.rerender('aa9addb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/components/ProductGeneralTab.vue"
export default component.exports